export const income: { [key: string]: string } = {
  PENDING_DATE: 'รอระบุวันที่',
  PENDING_APPROVAL: 'รอตรวจสอบ',
  PENDING_TRANSACTION: 'รอเงินเข้า',
  FINISHED: 'เงินเข้าแล้ว',

  CANCELLED: 'ยกเลิกแล้ว',
};

export const expense: { [key: string]: string } = {
  PENDING_DATE: 'รอระบุวันที่',
  PENDING_APPROVAL: 'รอตรวจสอบ',
  PENDING_CHEQUE_HANDOVER: 'เช็คพร้อมจ่าย',
  PENDING_TRANSACTION: 'รับเช็คไปแล้ว/รอวันโอน',
  FINISHED: 'ขึ้นเงินแล้ว/โอนเงินแล้ว',

  CANCELLED: 'ยกเลิกแล้ว',
};

export const expenseCheque: { [key: string]: string } = {
  PENDING_DATE: 'รอระบุวันที่ในเช็ค',
  PENDING_APPROVAL: 'รอตรวจสอบ',
  PENDING_CHEQUE_HANDOVER: 'เช็คพร้อมจ่าย',
  PENDING_TRANSACTION: 'รับเช็คไปแล้ว',
  FINISHED: 'ขึ้นเงินแล้ว',

  CANCELLED: 'ยกเลิกแล้ว',
};

export const expenseCash: { [key: string]: string } = {
  PENDING_DATE: 'รอลงวันโอน',
  PENDING_APPROVAL: 'รอตรวจสอบ',
  PENDING_CHEQUE_HANDOVER: 'INVALID STATUS',
  PENDING_TRANSACTION: 'ตรวจสอบแล้ว รอวันโอน',
  FINISHED: 'โอนเงินแล้ว',

  CANCELLED: 'ยกเลิกแล้ว',
};

export const expenseAction: { [key: string]: string } = {
  CONFIRM_DATE: 'ลงวันที่',
  APPROVE: 'ตรวจสอบ',
  CHEQUE_HANDOVER: 'รับเช็ค',
  PROCESS_TRANSACTION: 'ดำเนินการขึ้นเงิน/โอน',
  POSTPONE_DATE: 'เลื่อนวันที่',
  CANCEL: 'ยกเลิก',
};

export const expenseActionCheque: { [key: string]: string } = {
  CONFIRM_DATE: 'ลงวันที่เช็ค',
  APPROVE: 'ตรวจสอบเช็ค',
  CHEQUE_HANDOVER: 'รับเช็ค',
  PROCESS_TRANSACTION: 'ดำเนินการขึ้นเงินโดยผู้รับเงิน',

  POSTPONE_DATE: 'เลื่อนวันที่เช็ค',
  CANCEL: 'ยกเลิก',
};

export const expenseActionCash: { [key: string]: string } = {
  CONFIRM_DATE: 'ลงวันที่โอน',
  APPROVE: 'ตรวจสอบ',
  CHEQUE_HANDOVER: 'INVALID ACTION',
  PROCESS_TRANSACTION: 'โอนเงิน',

  POSTPONE_DATE: 'เลื่อนวันที่โอน',
  CANCEL: 'ยกเลิก',
};

export const incomeAction: { [key: string]: string } = {
  CONFIRM_DATE: 'ลงวันที่',
  APPROVE: 'ตรวจสอบ',
  PROCESS_TRANSACTION: 'รับเงิน',

  POSTPONE_DATE: 'เลื่อนวันที่',
  CANCEL: 'ยกเลิก',
};
